HRangePickerComponent.$inject = ['$element', '$scope', '$timeout', 'localize'];

function HRangePickerComponent($element, $scope, $timeout, localize) {
    let self = this;

    self.$postLink = function () {
        const slider = $element[0].querySelector('.slider');
        const direction = localize.isRTL() ? 'rtl' : 'ltr';
        let sliderConfig = {
            start: self.start,
            step: self.step,
            direction: direction,
            range: {
                'min': self.minValue,
                'max': self.maxValue
            },
            stepped: self.isStepped,
        }
        if (self.areValuePipsVisible) {
            sliderConfig.pips = {
                mode: 'values',
                values: [self.minValue, (self.minValue + self.maxValue) / 2, self.maxValue],
                density: 15
            }
        }
        noUiSlider.create(slider, sliderConfig);

        if (self.ngDisabled) {
            slider.classList.add('disabled-slider');
        }

        slider.noUiSlider.on('update', function (values, handle) {
            $timeout(function () {
                if (self.onUpdate) {
                    self.onUpdate({values: values.map(value => parseFloat(value))});
                }
            });
        });
    };

    self.$onChanges = function (changes) {
        if ($element[0] && $element[0].noUiSlider) {
            if (changes.start && changes.start.currentValue) {
                const currentValues = $element[0].noUiSlider.get().map(Number);
                const newValues = changes.start.currentValue.map(Number);

                if (JSON.stringify(currentValues) !== JSON.stringify(newValues)) {
                    $element[0].noUiSlider.set(newValues);
                }
            }
        }
    };

    self.$onDestroy = function () {
        if ($element[0].noUiSlider) {
            $element[0].noUiSlider.destroy();
        }
    }
}

angular
    .module("harriApp")
    .component("hRangePicker", {
        bindings: {
            start: '<',
            minValue: '<',
            maxValue: '<',
            areValuePipsVisible: '<',
            step: '<',
            ngDisabled: '<',
            isStepped: '<',
            onUpdate: '&',
        },
        template: `
        <style>
        .disabled-slider {
            pointer-events: none;
            opacity: 0.5;
        }
        </style>
        <div class='slider'></div>
        `,
        controller: HRangePickerComponent,
        controllerAs: '$ctrl',
    });